// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card_btn {
  width: auto;
  height: 50px;
  text-align: center;
  border-radius: 10px;
  position: relative;
  margin: 10px 10px;
  transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: white;
  box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
}

.card_subbtn {
  width: 75%;
  height: 40px;
  text-align: center;
  border-radius: 10px;
  position: relative;
  margin: 10px auto;
  transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: white;
  box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
}

.card__content {
  padding: 1.25em;
  height: 100%;
  display: flex;
  gap: 0.75em;
  align-items: center;
}

.card__image {
  width: 15%;
  height: 35px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto;
  border-radius: 12px;
}

.card__text {
  width: 100%;
  align-items: center;
  align-content: center;
  text-align: center;
}

.card__title {
  font-size: 17px;
  font-weight: 500;
  align-self: center;
  align-content: center;
  color: var(--ion-color-primary);
  margin: auto;
}

.card__icono {
  width: 15%;
  height: 50px;
  margin: 0 -15px 0 0;
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto;
  border-radius: 12px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/custom-side-menu/custom-side-menu.component.scss"],"names":[],"mappings":"AACA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kDAAA;EACA,0CAAA;EACA,iBAAA;EACA,8EAAA;EACA,yGAAA;AAAF;;AAIA;EACE,UAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kDAAA;EACA,0CAAA;EACA,iBAAA;EACA,8EAAA;EACA,yGAAA;AADF;;AAKA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;AAFF;;AAMA;EACE,UAAA;EACA,YAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,+BAAA;EACA,YAAA;AAHF;;AAMA;EACE,UAAA;EACA,YAAA;EACA,mBAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;EACA,mBAAA;AAHF","sourcesContent":["// CARDs\n.card_btn{\n  width: auto;\n  height: 50px;\n  text-align: center;\n  border-radius: 10px;\n  position: relative;\n  margin: 10px 10px;\n  transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  background: white;\n  box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen,\n    Ubuntu, Cantarell, sans-serif;\n}\n\n.card_subbtn{\n  width: 75%;\n  height: 40px;\n  text-align: center;\n  border-radius: 10px;\n  position: relative;\n  margin: 10px auto;\n  transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  background: white;\n  box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen,\n    Ubuntu, Cantarell, sans-serif;\n}\n\n.card__content {\n  padding: 1.25em;\n  height: 100%;\n  display: flex;\n  gap: 0.75em;\n  align-items: center;\n}\n\n\n.card__image {\n  width: 15%;\n  height: 35px;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: auto;\n  border-radius: 12px;\n}\n\n.card__text{\n  width: 100%;\n  align-items: center;\n  align-content: center;\n  text-align: center;\n}\n\n.card__title{\n  font-size: 17px;\n  font-weight: 500;\n  align-self: center;\n  align-content: center;\n  color: var(--ion-color-primary);\n  margin: auto;\n}\n\n.card__icono {\n  width: 15%;\n  height: 50px;\n  margin: 0 -15px 0 0;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: auto;\n  border-radius: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
